import { ComponentProps, ReactNode } from 'react';
import { Input as AriaInput } from 'react-aria-components';
import { twMerge } from 'tailwind-merge';
import { input, InputVariants } from '../../patterns/input';
import { inputWrapper } from './variants';

type Props = {
  className?: string;
  icon?: ReactNode;
  tooltipSlot?: ReactNode;
  fieldSize?: InputVariants['size'];
} & Omit<ComponentProps<typeof AriaInput>, 'className'>;

export function Input(props: Props) {
  const {
    className,
    icon,
    tooltipSlot,
    fieldSize = 'default',
    ...rest
  } = props;

  return (
    <div className={twMerge(inputWrapper({ size: fieldSize }), className)}>
      <AriaInput
        className={twMerge(
          input({ size: fieldSize }),
          'placeholder:font-light',
          'col-start-1',
          'col-end-4',
          'row-start-1',
          'row-end-1',
          'peer',
          icon && 'pl-48',
          tooltipSlot && 'pr-48',
        )}
        {...rest}
      />

      {tooltipSlot && (
        <div
          className={twMerge(
            'flex',
            'justify-center',
            'items-center',
            'col-start-3',
            'col-end-4',
            'row-start-1',
            'row-end-1',
          )}
        >
          {tooltipSlot}
        </div>
      )}

      {icon && (
        <span
          aria-hidden
          className={twMerge(
            'col-start-1',
            'col-end-1',
            'row-start-1',
            'row-end-1',
            'pointer-events-none',
            'place-self-center',
            'leading-0',
            'transition-colors',
            'duration-200',
            'ease-out',

            'fill-grayscale300',
            'peer-data-[hovered="true"]:fill-primaryMain',
            'peer-data-[focused="true"]:fill-primaryMain',
          )}
        >
          {icon}
        </span>
      )}
    </div>
  );
}
